import React, { useState } from 'react';
import './LoginPage.css';
import { login } from '../../api/admins';
import { Cookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';

const LoginPage = (props) => {
  const navigate = useNavigate()
  const cookie = new Cookies();
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true)
    login(email, password).then((result) => {
      if (result.data.message === "Login Successful!") {
        cookie.set("token", `Bearer ${result.data.token}`, {
          path: '/',
          maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
          sameSite: 'lax',
          secure: process.env.NODE_ENV === 'production',
        })
        cookie.set("isSuper", result.data.info.super_admin, {
          path: '/',
          maxAge: 30 * 24 * 60 * 60, // 30 days in seconds
          sameSite: 'lax',
          secure: process.env.NODE_ENV === 'production',
        })
        navigate("/", { replace: true })
        props.setIsLogin(true)
      } else {
        toast.error(result.data.message, {
          position: "top-right"
        })
      }
      setLoading(false)
    })
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h1 className="login-title">WELCOME</h1>
        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="input-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          {loading ? <div style={{
            width: "100%",
            justifyContent: "center",
            display: "flex"
          }}>
            <div className="spinner"></div>
          </div> : <button type="submit" className="login-button">
            Login
          </button>}
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default LoginPage;